import React from 'react';
import {
    Dialog,
    DialogTitle,
    DialogContent,
    TextField,
    DialogActions,
    Button,
    Alert,
    AlertTitle,
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    CircularProgress
} from '@mui/material';
import SelectMulti from './SelectMulti';

function CreateCompanyDialog({
                                 open,
                                 handleClose,
                                 editCompany,
                                 handleInputCreateChange,
                                 handleSave,
                                 users,
                                 smartHub,
                                 rixengine,
                             }) {
    return (
        <Dialog open={open} onClose={handleClose}>
            <DialogTitle>Create Company</DialogTitle>
            <DialogContent>
                <Alert variant="outlined" severity="info" color="info" sx={{marginBottom: "20px"}}>
                    Please complete this form to create a new company profile<br/>
                </Alert>

                <TextField
                    autoFocus
                    margin="dense"
                    id="name"
                    label="Company Name"
                    type="text"
                    fullWidth
                    name="name"
                    value={editCompany.name}
                    onChange={handleInputCreateChange}
                />

                <FormControl fullWidth margin="dense">
                    <InputLabel id="is-premium-label">Premium</InputLabel>
                    <Select
                        labelId="is-premium-label"
                        id="is_premium"
                        name="is_premium"
                        value={editCompany.is_premium}
                        onChange={handleInputCreateChange}
                        label="Premium"
                    >
                        <MenuItem value={true}>Yes</MenuItem>
                        <MenuItem value={false}>No</MenuItem>
                    </Select>
                </FormControl>

                <FormControl fullWidth margin="dense">
                    <InputLabel id="manager-label">Manager</InputLabel>
                    <Select
                        labelId="manager-label"
                        id="manager_id"
                        name="manager_id"
                        value={editCompany.manager_id}
                        onChange={handleInputCreateChange}
                        label="Manager"
                    >
                        {users.map((user) => (
                            <MenuItem key={user.value.id} value={user.value.id}>
                                {user.value.name}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>

                <TextField
                    margin="dense"
                    id="name"
                    label="Hyper ID"
                    type="text"
                    fullWidth
                    name="hyper_id"
                    value={editCompany.hyper}
                    onChange={handleInputCreateChange}
                />

                <FormControl fullWidth margin="dense">
                    <SelectMulti
                        label="SmartHub ID"
                        id="smarthub_id"
                        name="smarthub_id"
                        items={smartHub}
                        selectedItems={editCompany.smarthub_id}
                        onChange={handleInputCreateChange}
                        itemLabel="value.name"
                        itemKey="value.id"
                        itemValue="value.id"
                    />
                </FormControl>

                <FormControl fullWidth margin="dense">
                        <SelectMulti
                            label="RixEngine ID"
                            id="rixengine_id"
                            name="rixengine_id"
                            items={rixengine}
                            selectedItems={editCompany.rixengine_id}
                            onChange={handleInputCreateChange}
                            itemLabel="value.name"
                            itemKey="value.id"
                            itemValue="value.id"
                        />
                </FormControl>

            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={handleSave} color="primary">
                    Save
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default CreateCompanyDialog;